export const generateTimeOptions = (): string[] => {
	const times: string[] = []
	for (let hour = 0; hour < 24; hour++) {
		for (let minute = 0; minute < 60; minute += 15) {
			times.push(
				`${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
			)
		}
	}
	return times
}

export const TIME_OPTIONS = generateTimeOptions()

export const HOUR_OPTIONS = Array.from(
	{ length: 24 },
	(_, hour) => `${String(hour).padStart(2, '0')}:00`
)

export const MINUTE_TIME_OPTIONS = (() => {
	const times: string[] = []
	for (let hour = 0; hour < 24; hour++) {
		for (let minute = 0; minute < 60; minute++) {
			times.push(
				`${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
			)
		}
	}
	return times
})()
